import React from 'react';
import { Link } from 'react-router-dom';

export const MentionsLegales = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Mentions légales</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Éditeur du site</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site est édité par :<br />
              <strong>Richard SAAD</strong><br />
              Consultant informatique indépendant<br />
              Statut : Micro-entrepreneur<br />
              SIRET : 927 968 651 00012<br />
              Email : <a href="mailto:richard@saad-informatique.fr" className="text-blue-600 hover:text-blue-700 break-all">richard@saad-informatique.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Hébergement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site est hébergé par :<br />
              <strong>IONOS SARL</strong> (1&1 IONOS)<br />
              7, place de la Gare<br />
              57200 SARREGUEMINES<br />
              France<br />
              SIREN : 431 303 775
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Directeur de publication</h2>
            <p className="text-gray-600 leading-relaxed">
              Le directeur de la publication du site est Richard SAAD.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Propriété intellectuelle</h2>
            <p className="text-gray-600 leading-relaxed">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
              et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les 
              documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            <p className="text-gray-600 leading-relaxed mt-4">
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
              formellement interdite sauf autorisation expresse du directeur de la publication.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Limitation de responsabilité</h2>
            <p className="text-gray-600 leading-relaxed">
              Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement 
              remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes. Si vous 
              constatez une lacune, erreur ou ce qui paraît être un dysfonctionnement, merci de bien vouloir le 
              signaler par email à <a href="mailto:richard@saad-informatique.fr" className="text-blue-600 hover:text-blue-700 break-all">richard@saad-informatique.fr</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Liens hypertextes</h2>
            <p className="text-gray-600 leading-relaxed">
              Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres 
              ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de Richard SAAD.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Données personnelles</h2>
            <p className="text-gray-600 leading-relaxed">
              Pour plus d'informations sur la collecte et le traitement de vos données personnelles, veuillez 
              consulter notre <Link to="/confidentialite" className="text-blue-600 hover:text-blue-700">politique de confidentialité</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
